import ExcelJS from 'exceljs';

const UnscheduledAttendanceReportExcel = async (reportData: any) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Additional Attendance');

    worksheet.mergeCells('A1:M1');
    worksheet.getCell('A1').value = 'Additional Attendance';
    worksheet.getCell('A1').alignment = { horizontal: 'center' };
    worksheet.getCell('A1').font = { size: 16, bold: true };

    const headerRow = 3;
    worksheet.getRow(headerRow).values = [
        'Date',
        'Last Name',
        'First Name',
        'Position',
        'Site Attended',
        'Originally Scheduled At',
        'Clock In',
        'Clock Out',
        'Hours',
        'Added By',
        'Added At',
        'Paycode',
        'Code',
    ];
    worksheet.getRow(headerRow).font = { bold: true };

    const rows: any[] = Array.isArray(reportData) ? reportData : [];

    rows.forEach((row: any) => {
        const added = worksheet.addRow([
            row?.Date ?? '',
            row?.LastName ?? '',
            row?.FirstName ?? '',
            row?.Position ?? '',
            row?.SiteWorked ?? '',
            row?.ScheduledSite ?? '',
            // Left as "HH:mm" text so the spreadsheet does not reinterpret it as
            // a date, which is what happens to bare times in Excel.
            row?.ClockIn ?? '',
            row?.ClockOut ?? '',
            row?.Hours ?? '',
            row?.AddedBy ?? '',
            row?.AddedAt ?? '',
            row?.Paycode ?? '',
            row?.Code ?? '',
        ]);

        // An uncoded entry is on no timesheet yet, so it is the row somebody
        // has to act on: marked here rather than left to be spotted.
        if (row?.Coded === 'No') {
            added.font = { bold: true };
        }
    });

    // Enough width to read without hand-sizing every column.
    worksheet.columns.forEach((column, index) => {
        column.width = [12, 18, 16, 20, 28, 28, 10, 10, 8, 30, 20, 10, 10][index] ?? 16;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    return buffer;
};

export default UnscheduledAttendanceReportExcel;
